import { ToolbarButton } from './ToolbarButton';
import { SceneActions } from '../actions/SceneActions';
import { Stats } from '../utils/Stats';

export class ToolbarButtonClone extends ToolbarButton {
    public componentWillMount(): void {
        this.setState({active: false});
    }

    protected onClick = (): void => {
        SceneActions.cloneSelectedElements();
        Stats.sendEvent({
            category: 'Interaction',
            action: 'duplicate',
            label: null
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ToolbarButtonClone.tsx